import { Card, CardHeader, Modal, Table } from "reactstrap";
import React from "react";
import moment from "moment";

import useCallApi from "../../hooks/useCallApi";
import Loading from "../UI/Loading/Loading";
import TransactionDetailsContent from "./TransactionsDetailsContent/TransactionsDetailsContent";
import Dollars from "../UI/Dollars/Dollars";

const TransactionDetails = ({ transaction, showSystemMessage }) => {

    const { data, dataLoaded } = useCallApi(`accountBalance/transaction/${transaction.id}/details?transactionDate=${transaction.date}`, 'GET', {}, [transaction.id, transaction.date], showSystemMessage);

    return (
        <Card>
            <div>
                <CardHeader>Affiliate Transaction Details</CardHeader>
                <div>
                    {dataLoaded && data.success ? (
                        <Table striped bordered hover size="sm">
                            <tbody>
                                <tr>
                                    <td width="20%">Transaction Type: </td>
                                    <td width="80%">
                                        <span>{data.transaction_info.transaction_type}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="20%">Transaction Date: </td>
                                    <td width="80%">
                                        <span>{moment(data.transaction_info.transaction_date).format('YYYY-MM-DD')}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="20%">Amount: </td>
                                    <td width="80%">
                                        <span>
                                            <Dollars value={data.transaction_info.amount} />
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="20%">Notes: </td>
                                    <td width="80%">
                                        <span>{data.transaction_info.notes}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    ) : (
                        <Loading />
                    )}
                </div>
            </div>
            {dataLoaded && data.success ? (
                <>
                    <TransactionDetailsContent transactionHistory={data.transaction_history} showSystemMessage={showSystemMessage} transactionDate={moment(data.transaction_info.transaction_date).format('YYYY-MM-DD')} />
                </>
            ) : (
                <Loading />
            )}
        </Card>
    )
}

export default TransactionDetails;